import { forwardRef } from "react";
import { Form, Settings, SettingsItem, Select } from "ui";
import { MenuItem } from "@mui/material";
import GastroPaySellers from "./GastroPaySellers";
import GastroPayCommissions from "./GastroPayCommissions";
import FormRef from "../types/FormRef";

export type GastroPayModel = {
    commissions: [];
    currency: string;
    environment: "test" | "production";
    sellers: [];
};

type GastroPayFormProps = {
    data?: GastroPayModel;
    errors: any;
    loading: boolean;
    onSubmit: (data: GastroPayModel) => void;
};

const GastroPayForm = forwardRef<FormRef, GastroPayFormProps>(
    ({ data, errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={data ?? {}}
                errors={errors}
                fields={{
                    environment: { default: "production" },
                    currency: { default: "NOK" },
                    commissions: {
                        default: [
                            {
                                product_platform: "consumer",
                                payment_product_type: null,
                                domestic_percentage: 165,
                                domestic_fixed: 100,
                                eea_percentage: 165,
                                eea_fixed: 100,
                                eea_uk_percentage: 495,
                                eea_uk_fixed: 200,
                                europe_percentage: 495,
                                europe_fixed: 200,
                                inter_percentage: 495,
                                inter_fixed: 200,
                            },
                            {
                                product_platform: "commercial",
                                payment_product_type: null,
                                domestic_percentage: 495,
                                domestic_fixed: 200,
                                eea_percentage: 495,
                                eea_fixed: 200,
                                eea_uk_percentage: 495,
                                eea_uk_fixed: 200,
                                europe_percentage: 495,
                                europe_fixed: 200,
                                inter_percentage: 495,
                                inter_fixed: 200,
                            },
                            {
                                product_platform: "consumer",
                                payment_product_type: "klarna.klarna",
                                domestic_percentage: 165,
                                domestic_fixed: 100,
                                eea_percentage: 165,
                                eea_fixed: 100,
                                eea_uk_percentage: 495,
                                eea_uk_fixed: 200,
                                europe_percentage: 495,
                                europe_fixed: 200,
                                inter_percentage: 495,
                                inter_fixed: 200,
                            },
                        ],
                    },
                    sellers: { default: [] },
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                {(context: any) => {
                    return (
                        <>
                            <Settings>
                                <SettingsItem label="Environment">
                                    <Select
                                        fullWidth
                                        id="environment"
                                        margin="none"
                                    >
                                        <MenuItem value="test">Test</MenuItem>
                                        <MenuItem value="production">
                                            Production
                                        </MenuItem>
                                    </Select>
                                </SettingsItem>
                                {data === undefined && (
                                    <SettingsItem label="Currency">
                                        <Select
                                            fullWidth
                                            id="currency"
                                            margin="none"
                                        >
                                            <MenuItem value="NOK">NOK</MenuItem>
                                        </Select>
                                    </SettingsItem>
                                )}
                            </Settings>

                            <GastroPaySellers
                                context={context}
                                sellersId="sellers"
                                errors={errors?.sellers}
                            />

                            <GastroPayCommissions
                                context={context}
                                commissionsId="commissions"
                                errors={errors?.commissions}
                            />
                        </>
                    );
                }}
            </Form>
        );
    },
);

export default GastroPayForm;
